var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 2.61079H12.333C12.6866 2.61079 13.0258 2.75126 13.2758 3.00131C13.5259 3.25136 13.6663 3.5905 13.6663 3.94412V12.833C13.6663 13.1866 13.5259 13.5258 13.2758 13.7758C13.0258 14.0259 12.6866 14.1663 12.333 14.1663H1.66634C1.31272 14.1663 0.973581 14.0259 0.723532 13.7758C0.473484 13.5258 0.333008 13.1866 0.333008 12.833L0.333008 3.94412C0.333008 3.5905 0.473484 3.25136 0.723532 3.00131C0.973581 2.75126 1.31272 2.61079 1.66634 2.61079H2.99967V0.833008H3.88856V2.61079H10.1108V0.833008H10.9997V2.61079ZM5.66634 7.94412H2.99967V7.05523H5.66634V7.94412ZM10.9997 7.05523H8.33301V7.94412H10.9997V7.05523ZM5.66634 10.6108H2.99967V9.7219H5.66634V10.6108ZM8.33301 10.6108H10.9997V9.7219H8.33301V10.6108Z",
    fill: "#393839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.fcc5499edefb57c172707a1b370ef855.svg";
export { ForwardRef as ReactComponent };